import { h, Component } from 'preact'

export default class Separator extends Component {
  render() {
    const { packed, bg } = this.props
    return (
      <div
        className={this.props.className}
        style={{
          fontSize: 22,
          position: 'relative',
          top: 20,
          textAlign: 'center',
          margin: packed ? '0' : '20px 0',
        }}
        onClick={this.props.onClick}
      >
        <div
          style={{
            width: '100%',
            height: 1,
            background: '#ccc',
            position: 'absolute',
            top: packed ? 8 : -2,
            left: 0,
          }}
        />
        <div
          style={{
            display: 'inline',
            background: bg || '#e6e6e6',
            color: '#9b9b9b',
            padding: '0 10px',
            position: 'relative',
            top: packed ? -6 : -16,
          }}
        >
          {this.props.children}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/layout/Separator.js